import { Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ParallaxDirective } from '../parallax.directive';
import { SocialLinks } from '../social-links/social-links';
import { ScrollToSectionDirective } from '../scroll-to-section.directive';
import { Toast } from '../toast/toast';

interface HeroNavLink {
  path: string;
  label: string;
  // Present only for links that scroll to a section on the home
  // page instead of (always, or below breakpoint) routing there --
  // see ScrollToSectionDirective.
  sectionId?: string;
  breakpoint?: number;
  // Section exists on every route (e.g. the footer) -- always just
  // scrolls in place, never navigates.
  global?: boolean;
}

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [RouterLink, ParallaxDirective, SocialLinks, ScrollToSectionDirective],
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class Hero {
  protected readonly toast = inject(Toast);

  @Input() imageSrc = '/images/bonefade-source/SQS_DK_carlos_0226-e.jpg';
  @Input() imageAlt = 'Borbély munka közben';

  // "Rólunk" has no page of its own -- it always scrolls to
  // .bf-summary (id="bf-summary") on the home page.
  // "Árak"/"Galéria" keep their standalone pages on desktop, but
  // below 1024px they scroll to the matching section embedded on
  // the home page instead.
  protected readonly navLinks: HeroNavLink[] = [
    { path: '/', label: 'Kezdőlap' },
    { path: '/', label: 'Rólunk', sectionId: 'bf-summary' },
    { path: '/arak', label: 'Árak', sectionId: 'price-list', breakpoint: 1024 },
    { path: '/galeria', label: 'Galéria', sectionId: 'gallery-grid', breakpoint: 1024 },
    { path: '/', label: 'Kapcsolat', sectionId: 'kapcsolat', global: true },
  ];
}
